module.exports = __webpack_public_path__ + "img/nzd_fiatrail.35f22ee.png";